// 개인정보 처리방침 · 이용약관 (KR/EN/JP). 출처: Bwek_Privacy_ToS_KR-EN-JP.md (납품 초안).
// ⚠️ 법률 자문 아님 — 출시 전 각 시장 변호사 검토 필수. 텍스트는 원문 그대로.

import type { Lang } from "../lib/types";

export interface LegalSection {
  h: string; // 소제목 (예: "1. 기본 원칙")
  body: string[]; // 문단/불릿 (불릿은 "· "로 시작)
}
export interface LegalDoc {
  title: string;
  effective: string;
  intro: string[];
  sections: LegalSection[];
}
export type LegalKind = "privacy" | "terms";

export const LEGAL: Record<Lang, Record<LegalKind, LegalDoc>> = {
  ko: {
    privacy: {
      title: "개인정보 처리방침",
      effective: "시행일: 2026년 6월 16일",
      intro: [
        'Gorocket Company Inc.(이하 "회사")은 Bwek(이하 "서비스") 이용자의 개인정보를 중요하게 생각하며, 「개인정보 보호법」 등 관련 법령을 준수합니다.',
      ],
      sections: [
        {
          h: "1. 기본 원칙",
          body: [
            "서비스는 계정·로그인이 없으며, 이름·이메일 등 식별정보를 수집하지 않습니다. 이용자가 작성·발화한 내용은 서버에 저장하지 않습니다.",
          ],
        },
        {
          h: "2. 수집·처리하는 정보",
          body: [
            "· 입력 콘텐츠: 이용자가 작성하거나 음성으로 말한 텍스트. 점수 산정과 안전(위기·범위) 판정을 위해 일시적으로 처리된 뒤 폐기됩니다.",
            "· 행동 신호: 타이핑 리듬·삭제 횟수·소요 시간, 마이크 사용 시 음량·음높이. 점수 산정에 쓰입니다.",
            "· 음성: 마이크 사용 시 음성을 텍스트로 변환(STT)하기 위해 처리합니다.",
            "· 광고·기기 정보: 광고 제공을 위해 광고 식별자, IP, 기기 정보 등이 광고 파트너를 통해 처리될 수 있습니다.",
            "· 로컬 데이터: 배지 등 일부 정보는 이용자 기기에만 저장됩니다(서버 전송 없음).",
          ],
        },
        {
          h: "3. 이용 목적",
          body: [
            "빡침 점수 산정 및 한 줄 코멘트 생성, 안전 판정(자해·위기 신호 감지 시 지원 정보 안내), 광고 제공, 기기 내 기능 제공.",
          ],
        },
        {
          h: "4. 저장하지 않는 것 / 학습에 쓰지 않는 것",
          body: [
            "입력 콘텐츠는 처리 후 폐기되며 서버에 저장하지 않습니다. 입력 콘텐츠는 AI 모델 학습에 사용하지 않습니다. 회사는 개인정보를 판매하지 않습니다.",
          ],
        },
        {
          h: "5. 처리위탁·제3자",
          body: [
            "· AI 처리: Google Vertex AI(콘텐츠 점수·안전 판정).",
            "· 음성 변환(STT): 음성→텍스트 변환 처리자.",
            "· 광고: Google AdMob(앱) / AdSense(웹).",
            "각 사의 처리방침은 해당 사 정책을 따릅니다.",
          ],
        },
        {
          h: "6. 광고와 동의",
          body: [
            "광고 파트너는 광고 제공을 위해 정보를 수집·이용할 수 있습니다. EEA·영국 등에서는 동의에 따라, iOS에서는 앱 추적 투명성(ATT)에 따라 처리됩니다. 광고 맞춤설정은 기기 설정에서 제한할 수 있습니다.",
          ],
        },
        {
          h: "7. 보유 기간",
          body: [
            "입력 콘텐츠: 처리 직후 폐기(미보관). 로컬 배지: 이용자가 삭제하기 전까지 기기에 보관. 광고·분석 데이터: 각 파트너 정책에 따름.",
          ],
        },
        {
          h: "8. 이용자 권리",
          body: [
            "이용자는 관련 법령에 따라 열람·정정·삭제·처리정지 등을 요청할 수 있습니다. 다만 서비스는 서버에 개인정보를 보관하지 않으므로, 로컬 데이터는 기기에서 직접 삭제할 수 있습니다. 문의: support@gorocket.me.",
          ],
        },
        {
          h: "9. 아동의 개인정보",
          body: [
            "서비스는 만 14세 미만을 대상으로 하지 않습니다. 해당 연령 미만으로 확인될 경우 처리하지 않습니다.",
          ],
        },
        {
          h: "10. 국외 이전",
          body: ["AI·광고 처리 과정에서 정보가 국외(미국 등)에서 처리될 수 있습니다."],
        },
        { h: "11. 안전성 확보 조치", body: ["전송 구간 암호화 등 합리적인 보호조치를 적용합니다."] },
        { h: "12. 변경", body: ["본 방침 변경 시 서비스 내 또는 웹사이트에 고지합니다."] },
        {
          h: "13. 문의",
          body: [
            "Gorocket Company Inc. · 충청남도 천안시 서북구 천안천4길 32, 그린스타트업타운 311호 · support@gorocket.me",
          ],
        },
      ],
    },
    terms: {
      title: "이용약관",
      effective: "시행일: 2026년 6월 16일",
      intro: [],
      sections: [
        { h: "1. 동의", body: ["서비스를 이용함으로써 본 약관에 동의하게 됩니다."] },
        {
          h: "2. 서비스 정의",
          body: [
            "Bwek은 이용자가 쏟아낸 분노를 점수와 한 줄로 받아치는 엔터테인먼트·코미디 서비스입니다. 점수와 코멘트는 재미를 위한 것으로 정확한 측정이 아닙니다.",
          ],
        },
        {
          h: "3. 의료·상담 서비스 아님",
          body: [
            "Bwek은 의료·심리상담·위기개입 서비스가 아니며 이를 대체하지 않습니다. 긴급하거나 위기 상황이라면 전문기관 또는 긴급 연락처에 연락하시기 바랍니다.",
          ],
        },
        { h: "4. 이용 자격·연령", body: ["만 14세 이상만 이용할 수 있습니다."] },
        {
          h: "5. 이용자의 책임",
          body: [
            "이용자는 자신이 입력한 내용에 책임이 있습니다. 타인의 개인정보, 불법·권리침해 콘텐츠를 입력하지 마십시오. 입력 콘텐츠는 처리 후 폐기됩니다.",
          ],
        },
        {
          h: "6. 자동 생성물",
          body: ["점수·코멘트·유형은 자동 생성되며 재미를 위한 것입니다. 부정확하거나 의도와 다를 수 있습니다."],
        },
        {
          h: "7. 광고·제3자",
          body: [
            "서비스에는 광고가 포함되며, 제3자 서비스(광고·AI 등)가 사용됩니다. 제3자 서비스에는 해당 사 약관·정책이 적용됩니다.",
          ],
        },
        {
          h: "8. 지식재산권",
          body: [
            '서비스, "Bwek" 명칭·로고 등 일체의 권리는 회사에 귀속됩니다. 이용자가 입력한 내용에 대한 권리는 이용자에게 있으나, 해당 내용은 처리 후 폐기됩니다.',
          ],
        },
        {
          h: "9. 보증의 부인",
          body: ['서비스는 "있는 그대로" 제공되며, 특정 목적 적합성 등 어떠한 보증도 하지 않습니다.'],
        },
        {
          h: "10. 책임의 제한",
          body: [
            "관련 법령이 허용하는 범위에서, 회사는 서비스 이용으로 인한 간접·부수적 손해에 대해 책임지지 않습니다.",
          ],
        },
        { h: "11. 해지", body: ["회사는 약관 위반 등의 경우 이용을 제한할 수 있습니다."] },
        {
          h: "12. 준거법·관할",
          body: [
            "본 약관은 대한민국 법을 준거법으로 하며, 회사의 본점 소재지를 관할하는 법원을 전속적 합의관할 법원으로 합니다.",
          ],
        },
        { h: "13. 변경", body: ["약관 변경 시 서비스 내 또는 웹사이트에 고지합니다."] },
        { h: "14. 문의", body: ["Gorocket Company Inc. · support@gorocket.me"] },
      ],
    },
  },
  en: {
    privacy: {
      title: "Privacy Policy",
      effective: "Effective date: June 16, 2026",
      intro: [
        'Gorocket Company Inc. ("we") respects your privacy and complies with applicable laws (including CCPA/CPRA, GDPR where applicable, and others).',
      ],
      sections: [
        {
          h: "1. Core principle",
          body: [
            'Bwek ("the Service") has no accounts or login and does not collect identifying information such as your name or email. What you write or speak is not stored on our servers.',
          ],
        },
        {
          h: "2. Information we process",
          body: [
            "· Input content: the text you write or speak. Processed transiently to generate your score and to run safety (crisis/scope) checks, then discarded.",
            "· Behavioral signals: typing rhythm, deletions, timing, and (when the mic is used) loudness and pitch. Used to compute the score.",
            "· Voice: when you use the mic, audio is processed to convert speech to text.",
            "· Advertising/device data: advertising identifiers, IP, and device information may be processed by ad partners to serve ads.",
            "· Local data: some data (such as badges) is stored only on your device and not sent to us.",
          ],
        },
        {
          h: "3. How we use it",
          body: [
            "To score your rant and generate a one-line response; for safety (detecting self-harm/crisis signals to show support resources); to serve ads; and for on-device features.",
          ],
        },
        {
          h: "4. What we don't do",
          body: [
            "We do not store your input content on our servers; it is discarded after processing. We do not use your input content to train AI models. We do not sell your personal information.",
          ],
        },
        {
          h: "5. Processors / third parties",
          body: [
            "· AI processing: Google Vertex AI (scoring and safety checks).",
            "· Speech-to-text: a speech-to-text processor (when the mic is used).",
            "· Advertising: Google AdMob (apps) / AdSense (web).",
            "Their handling is governed by their own policies.",
          ],
        },
        {
          h: "6. Ads and consent",
          body: [
            'Ad partners may collect and use data to serve ads. In the EEA/UK this is subject to consent; on iOS it is subject to App Tracking Transparency (ATT). You can limit ad personalization in your device settings. Where applicable, you may opt out of "sharing" of personal information for cross-context advertising.',
          ],
        },
        {
          h: "7. Retention",
          body: [
            "Input content: discarded immediately after processing (not retained). Local badges: kept on your device until you clear them. Ad/analytics data: per each partner's policy.",
          ],
        },
        {
          h: "8. Your rights",
          body: [
            "Subject to applicable law (e.g., access, deletion, correction, opt-out). Because we do not hold personal data on our servers, local data can be cleared directly on your device. Contact: support@gorocket.me.",
          ],
        },
        {
          h: "9. Children",
          body: [
            "The Service is not directed to anyone under 14. We do not knowingly process data from anyone under that age.",
          ],
        },
        {
          h: "10. International transfers",
          body: [
            "Information may be processed outside your country (e.g., in the United States) for AI and advertising.",
          ],
        },
        { h: "11. Security", body: ["We apply reasonable safeguards, including encryption in transit."] },
        { h: "12. Changes", body: ["We will post changes in the app or on our website."] },
        {
          h: "13. Contact",
          body: [
            "Gorocket Company Inc. · Room 311, Green Startup Town, 32 Cheonancheon 4-gil, Seobuk-gu, Cheonan-si, Chungcheongnam-do, Republic of Korea · support@gorocket.me",
          ],
        },
      ],
    },
    terms: {
      title: "Terms of Service",
      effective: "Effective date: June 16, 2026",
      intro: [],
      sections: [
        { h: "1. Acceptance", body: ["By using the Service you agree to these Terms."] },
        {
          h: "2. The Service",
          body: [
            "Bwek is an entertainment / comedy service that scores the anger you pour out and answers with one line. Scores and comments are for fun and are not accurate measurements.",
          ],
        },
        {
          h: "3. Not a medical or counseling service",
          body: [
            "Bwek is not a medical, mental-health, counseling, or crisis-intervention service and is not a substitute for one. If this is an emergency or crisis, please contact a professional or an emergency hotline.",
          ],
        },
        { h: "4. Eligibility", body: ["You must be at least 14 to use the Service."] },
        {
          h: "5. Your responsibilities",
          body: [
            "You are responsible for what you enter. Do not input other people's personal information or unlawful/infringing content. Input content is discarded after processing.",
          ],
        },
        {
          h: "6. Automated output",
          body: [
            "Scores, comments, and types are automatically generated and intended for fun. They may be inaccurate or unexpected.",
          ],
        },
        {
          h: "7. Ads and third parties",
          body: [
            "The Service contains ads and uses third-party services (advertising, AI). Third-party services are governed by their own terms.",
          ],
        },
        {
          h: "8. Intellectual property",
          body: [
            'The Service and the "Bwek" name and logo belong to the Company. You retain rights to what you input, but that content is discarded after processing.',
          ],
        },
        {
          h: "9. Disclaimer of warranties",
          body: [
            'The Service is provided "as is," without warranties of any kind, including fitness for a particular purpose.',
          ],
        },
        {
          h: "10. Limitation of liability",
          body: [
            "To the extent permitted by law, the Company is not liable for indirect or incidental damages arising from use of the Service.",
          ],
        },
        { h: "11. Termination", body: ["We may restrict use in cases such as violation of these Terms."] },
        {
          h: "12. Governing law",
          body: [
            "These Terms are governed by the laws of the Republic of Korea, and the court having jurisdiction over the Company's principal place of business shall have exclusive jurisdiction.",
          ],
        },
        { h: "13. Changes", body: ["We will post changes in the app or on our website."] },
        { h: "14. Contact", body: ["Gorocket Company Inc. · support@gorocket.me"] },
      ],
    },
  },
  ja: {
    privacy: {
      title: "プライバシーポリシー",
      effective: "施行日: 2026年6月16日",
      intro: [
        "Gorocket Company Inc.（以下「当社」）は、Bwek（以下「本サービス」）利用者のプライバシーを尊重し、個人情報の保護に関する法律（APPI）等の関連法令を遵守します。",
      ],
      sections: [
        {
          h: "1. 基本方針",
          body: [
            "本サービスにはアカウント・ログインがなく、氏名・メールアドレス等の識別情報を収集しません。利用者が書いた、または話した内容はサーバーに保存しません。",
          ],
        },
        {
          h: "2. 取り扱う情報",
          body: [
            "· 入力内容: 利用者が書いた、または音声で話したテキスト。スコア算定と安全（危機・範囲）判定のため一時的に処理し、その後破棄します。",
            "· 行動データ: タイピングのリズム・削除回数・所要時間、マイク使用時は音量・音の高さ。スコア算定に使用します。",
            "· 音声: マイク使用時、音声をテキストに変換（STT）するため処理します。",
            "· 広告・端末情報: 広告配信のため、広告識別子・IP・端末情報等が広告パートナーを通じて処理される場合があります。",
            "· ローカルデータ: バッジ等の一部情報は利用者の端末内のみに保存します（サーバー送信なし）。",
          ],
        },
        {
          h: "3. 利用目的",
          body: [
            "スコア算定および一言コメントの生成、安全判定（自傷・危機の兆候を検知した場合の相談先案内）、広告配信、端末内機能の提供。",
          ],
        },
        {
          h: "4. 保存しないこと・学習に使わないこと",
          body: [
            "入力内容は処理後に破棄し、サーバーに保存しません。入力内容をAIモデルの学習には使用しません。当社は個人情報を販売しません。",
          ],
        },
        {
          h: "5. 委託先・第三者",
          body: [
            "· AI処理: Google Vertex AI（スコア・安全判定）。",
            "· 音声変換（STT）: 音声テキスト変換の処理者。",
            "· 広告: Google AdMob（アプリ）／ AdSense（ウェブ）。",
            "各社の取り扱いは各社のポリシーに従います。",
          ],
        },
        {
          h: "6. 広告と同意",
          body: [
            "広告パートナーは広告配信のため情報を収集・利用する場合があります。EEA・英国等では同意に基づき、iOSではApp Tracking Transparency（ATT）に基づき処理されます。広告のパーソナライズは端末設定で制限できます。",
          ],
        },
        {
          h: "7. 保存期間",
          body: [
            "入力内容: 処理後ただちに破棄（保存しない）。ローカルバッジ: 利用者が削除するまで端末に保存。広告・分析データ: 各パートナーのポリシーに従う。",
          ],
        },
        {
          h: "8. 利用者の権利",
          body: [
            "関連法令に基づき、開示・訂正・削除・利用停止等を請求できます。本サービスはサーバーに個人情報を保存しないため、ローカルデータは端末から直接削除できます。お問い合わせ: support@gorocket.me。",
          ],
        },
        {
          h: "9. 子どもの個人情報",
          body: ["本サービスは 14 歳未満を対象としていません。当該年齢未満と判明した場合、処理しません。"],
        },
        {
          h: "10. 国外移転",
          body: ["AI・広告の処理の過程で、情報が国外（米国等）で処理される場合があります。"],
        },
        { h: "11. 安全管理措置", body: ["通信の暗号化等、合理的な保護措置を講じます。"] },
        { h: "12. 変更", body: ["本ポリシーを変更する場合、アプリ内またはウェブサイトで告知します。"] },
        {
          h: "13. お問い合わせ",
          body: [
            "Gorocket Company Inc. · 大韓民国 忠清南道 天安市 西北区 天安川4ギル32 グリーンスタートアップタウン311号 · support@gorocket.me",
          ],
        },
      ],
    },
    terms: {
      title: "利用規約",
      effective: "施行日: 2026年6月16日",
      intro: [],
      sections: [
        { h: "1. 同意", body: ["本サービスを利用することで、本規約に同意したものとみなします。"] },
        {
          h: "2. サービスの定義",
          body: [
            "Bwekは、利用者が吐き出した怒りをスコアと一言で返すエンターテインメント・コメディサービスです。スコアやコメントは娯楽のためのもので、正確な測定ではありません。",
          ],
        },
        {
          h: "3. 医療・相談サービスではありません",
          body: [
            "Bwekは医療・メンタルヘルス・カウンセリング・危機介入サービスではなく、これらに代わるものではありません。緊急時や危機的状況の場合は、専門機関または緊急相談窓口にご連絡ください。",
          ],
        },
        { h: "4. 利用資格・年齢", body: ["本サービスは 14 歳以上の方のみ利用できます。"] },
        {
          h: "5. 利用者の責任",
          body: [
            "入力した内容について利用者が責任を負います。他人の個人情報や違法・権利侵害となる内容を入力しないでください。入力内容は処理後に破棄されます。",
          ],
        },
        {
          h: "6. 自動生成物",
          body: ["スコア・コメント・タイプは自動生成され、娯楽を目的とします。不正確であったり、意図と異なる場合があります。"],
        },
        {
          h: "7. 広告・第三者",
          body: [
            "本サービスには広告が含まれ、第三者サービス（広告・AI等）を利用します。第三者サービスには各社の規約・ポリシーが適用されます。",
          ],
        },
        {
          h: "8. 知的財産権",
          body: [
            "本サービス、「Bwek」の名称・ロゴ等の一切の権利は当社に帰属します。利用者が入力した内容の権利は利用者に帰属しますが、当該内容は処理後に破棄されます。",
          ],
        },
        {
          h: "9. 保証の否認",
          body: ["本サービスは「現状有姿」で提供され、特定目的への適合性を含むいかなる保証も行いません。"],
        },
        {
          h: "10. 責任の制限",
          body: [
            "法令が認める範囲において、当社は本サービスの利用に起因する間接・付随的損害について責任を負いません。",
          ],
        },
        { h: "11. 利用の停止", body: ["当社は、本規約違反等の場合、利用を制限できます。"] },
        {
          h: "12. 準拠法・管轄",
          body: [
            "本規約は大韓民国法を準拠法とし、当社の本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。",
          ],
        },
        { h: "13. 変更", body: ["本規約を変更する場合、アプリ内またはウェブサイトで告知します。"] },
        { h: "14. お問い合わせ", body: ["Gorocket Company Inc. · support@gorocket.me"] },
      ],
    },
  },
};
